import React from 'react';
import { twMerge } from 'tailwind-merge';
import { CategoryType } from '@diritto/common/content/constants';

export type CategoryFilterItem = {
  title: string;
  value: CategoryType;
  checked?: boolean;
  onClick?: () => void;
};

interface CategoryFilterItemListProps {
  className?: string;
  items: CategoryFilterItem[];
  onClick?: () => void;
}

export const CategoryFilterItemList = ({ className, items, onClick }: CategoryFilterItemListProps) => (
  <ul
    className={twMerge(
      'absolute top-[calc(100%+8px)] right-0 w-[120px] p-2 bg-white z-[999]',
      'rounded border border-solid border-black/10',
      'shadow-[0px_10px_20px_0px_rgba(0,0,0,0.10)]',
      className,
    )}
    onClick={onClick}>
    {items.map(item => (
      <li
        key={`${item.title}_${item.value}`}
        className={'flex cursor-pointer w-full px-4 py-[13.5px] hover:bg-gray-100 rounded'}
        onClick={() => item.onClick?.()}>
        <label className="flex cursor-pointer w-full text-left text-xxs">
          <p className={item.checked ? 'text-primary-500 font-bold' : 'font-medium'}>{item.title}</p>
        </label>
      </li>
    ))}
  </ul>
);
